import { SheetField } from "./SaitenList"

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number
  subject_code: number
  report_no: number
  name: string
  field_names_completed: boolean

  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.subject_code = base_sheet.subject_code;
    this.report_no = base_sheet.report_no;
    this.name = base_sheet.name;
    this.field_names_completed = base_sheet.field_names_completed;
  }
}

export class BaseSheetField {
  id: number
  kind: number
  part1: string
  part2: string
  part3: string
  allot: number
  allot_cache: number
  page: number
  view_point_id: number
  scoring_type: number
  scoring_type_cache: number
  correct_text: string
  digital_correct_text: string
  answer_type: number
  choice_texts: string
  choice_correct_text: string

  constructor(sheet_field_base: any){
    this.id = sheet_field_base.id;
    this.kind = sheet_field_base.kind;
    this.part1 = sheet_field_base.part1;
    this.part2 = sheet_field_base.part2;
    this.part3 = sheet_field_base.part3;
    this.allot = sheet_field_base.allot;
    this.allot_cache = sheet_field_base.allot;
    this.page = sheet_field_base.page;
    this.view_point_id = sheet_field_base.view_point_id;
    this.scoring_type = sheet_field_base.scoring_type;
    this.scoring_type_cache = sheet_field_base.scoring_type;
    this.correct_text = sheet_field_base.correct_text;
    this.digital_correct_text = sheet_field_base.digital_correct_text;
    this.answer_type = sheet_field_base.answer_type;
    this.choice_texts = sheet_field_base.choice_texts;
    this.choice_correct_text = sheet_field_base.choice_correct_text;
  }
}